module.exports = __webpack_public_path__ + "static/media/martialArts.41e3241c.svg";